import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { AppService } from '@services/app.service';

import { environment } from '../../environments/environment';

const REQUEST_METHODS_AUTOLOAD: readonly string[] = ['POST', 'PUT', 'DELETE'];

const SKIP_REQUESTS_URL: readonly string[] = [
  `${environment.baseUrl}drive-sense/api/v1/objects_info/actual`,
  `${environment.apiUrl}geocoding/reverse/`,
  `${environment.apiUrl}messages/get`,
  `${environment.apiUrl}messages/stat`,
  `${environment.apiUrl}messages/chart`,
  `${environment.apiUrl}messages/point_info/`,
  `${environment.apiUrl}reports/special_data/`,
  `${environment.apiUrl}tracks/create/`,
  `${environment.apiUrl}objects/send_command/`,
  `${environment.apiUrl}objects/set_map_visibility/`,
  `${environment.apiUrl}geozone/objects_inside/`,
  `${environment.apiUrl}geozone/import/get_geozone_names_from_file/`,
  `${environment.apiUrl}cms/accounts/excel/`,
  `${environment.apiUrl}cms/objects/excel/`,
  `${environment.apiUrl}cms/users/excel/`,
  `${environment.apiUrl}cms/objects/mass_activate/`,
];

export const loaderInterceptor: HttpInterceptorFn = (request, next) => {
  const isAutoLoad =
    REQUEST_METHODS_AUTOLOAD.includes(request.method) &&
    !SKIP_REQUESTS_URL.includes(request.url) &&
    !request.url.includes('/activate/') &&
    !isRetransmissionsRequest(request);

  if (!isAutoLoad) {
    return next(request);
  }

  const appService = inject(AppService);
  appService.isLoading.next(true);

  return next(request).pipe(finalize(() => appService.isLoading.next(false)));
};

function isRetransmissionsRequest(request: HttpRequest<unknown>): boolean {
  return (
    request.url.startsWith(`${environment.apiUrl}cms/retranslators/`) &&
    (request.url.endsWith('/retransmissions/') ||
      request.url.endsWith('/stop/') ||
      request.url.endsWith('/pause/') ||
      request.url.endsWith('/resume/'))
  );
}
